module.exports = __webpack_public_path__ + "static/media/coliseu_porto_ageas_circo_2023_08.7b6f9e6d.webp";